import { tagNames } from './Tags.js';
import { decodeUTF8 } from './Util.js';
export class NbtReader {
    offset;
    littleEndian;
    array;
    view;
    constructor(array, options = {}) {
        this.offset = options.offset ?? 0;
        this.littleEndian = options.littleEndian ?? false;
        this.array = array;
        this.view = new DataView(array.buffer, array.byteOffset);
    }
    end() {
        return null;
    }
    readNum(type, size) {
        const value = this.view[type](this.offset, this.littleEndian);
        this.offset += size;
        return value;
    }
    byte = this.readNum.bind(this, 'getInt8', 1);
    short = this.readNum.bind(this, 'getInt16', 2);
    int = this.readNum.bind(this, 'getInt32', 4);
    float = this.readNum.bind(this, 'getFloat32', 4);
    double = this.readNum.bind(this, 'getFloat64', 8);
    long() {
        return [this.int(), this.int()];
    }
    byteArray() {
        const length = this.int();
        const values = [];
        for (let i = 0; i < length; i++) {
            values.push(this.byte());
        }
        return values;
    }
    intArray() {
        const length = this.int();
        const values = [];
        for (let i = 0; i < length; i++) {
            values.push(this.int());
        }
        return values;
    }
    longArray() {
        const length = this.int();
        const values = [];
        for (let i = 0; i < length; i++) {
            values.push(this.long());
        }
        return values;
    }
    string() {
        const length = this.short();
        const slice = this.array.slice(this.offset, this.offset + length);
        this.offset += length;
        return decodeUTF8(slice);
    }
    list() {
        const type = tagNames[this.byte()];
        const length = this.int();
        const values = [];
        for (let i = 0; i < length; i++) {
            values.push(this[type]());
        }
        return { type, value: values };
    }
    compound() {
        const values = {};
        while (true) {
            const type = tagNames[this.byte()];
            if (type === 'end') {
                break;
            }
            const name = this.string();
            const value = this[type]();
            values[name] = { type, value };
        }
        return values;
    }
}
//# sourceMappingURL=Reader.js.map